import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { FileText, Download, Upload } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

const PayrollsModal = ({
  showPayrollsModal,
  setShowPayrollsModal,
  selectedEmployee,
  handlePayrollUpload,
  payrolls
}) => {
  return (
    <Dialog open={showPayrollsModal} onOpenChange={setShowPayrollsModal}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="payrolls-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-blue-600" />
            Maaş Bordroları - {selectedEmployee?.name}
          </DialogTitle>
          <DialogDescription>
            {selectedEmployee?.name} isimli çalışana ait geçmiş bordrolar
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-6 py-4">
          <div className="flex flex-col gap-4 p-4 border rounded-lg bg-slate-50">
            <h4 className="font-medium text-sm text-slate-800">Yeni Bordro Yükle</h4>
            <div className="flex gap-4">
              <div className="grid grid-cols-2 gap-4 flex-1">
                <div className="space-y-2">
                  <Label>Yıl</Label>
                  <Input id="payroll-year" type="number" defaultValue={new Date().getFullYear()} />
                </div>
                <div className="space-y-2">
                  <Label>Ay</Label>
                  <Input id="payroll-month" type="number" min="1" max="12" defaultValue={new Date().getMonth() + 1} />
                </div>
              </div>
              <div className="flex items-end">
                <Label htmlFor="payroll-upload" className="cursor-pointer">
                  <div className="bg-white border rounded-md px-4 py-2 hover:bg-slate-50 flex items-center gap-2 h-10">
                    <Upload className="w-4 h-4 text-slate-600" />
                    <span className="text-sm font-medium">Bordro Seç</span>
                  </div>
                  <Input 
                    id="payroll-upload"
                    type="file"
                    className="hidden"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    onChange={(e) => {
                      const year = document.getElementById('payroll-year').value;
                      const month = document.getElementById('payroll-month').value;
                      if (!year || !month) {
                        alert("Lütfen önce Yıl ve Ay bilgilerini girin");
                        return;
                      }
                      handlePayrollUpload(e, year, month);
                    }}
                  />
                </Label>
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <h4 className="font-medium text-sm text-slate-800 border-b pb-2">Geçmiş Bordrolar</h4>
            
            {payrolls && payrolls.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                {payrolls.map((payroll, idx) => (
                  <div key={idx} className="flex items-center justify-between p-3 border rounded-md hover:bg-slate-50">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-blue-100 rounded-md text-blue-700">
                        <FileText className="w-4 h-4" />
                      </div>
                      <div>
                        <p className="text-sm font-medium">{payroll.year} Yılı {payroll.month}. Ay Bordrosu</p>
                        <p className="text-xs text-slate-500">{new Date(payroll.created_at).toLocaleDateString('tr-TR')}</p>
                      </div>
                    </div>
                    <Button 
                      variant="ghost" 
                      size="sm"
                      className="h-8 w-8 p-0"
                      onClick={() => window.open(payroll.file_url, '_blank')}
                    >
                      <Download className="w-4 h-4 text-slate-600" />
                    </Button>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-8 text-slate-500 text-sm bg-slate-50 rounded-lg border border-dashed">
                Henüz bordro yüklenmemiş
              </div>
            )}
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => setShowPayrollsModal(false)}>Kapat</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default PayrollsModal;